import { z } from 'zod';

export const SourceTaxTypeSchema = z.enum(['DOMESTIC', 'INTERNATIONAL']);
export const CountrySchema = z.object({
  id: z.string().nullable(),
  name: z.string(),
  description: z.string().nullish(),
  rating: z.string(),
  domestic_taxation_applicable: z.boolean().nullish(),
  source_tax_applicable: z.boolean().nullish(),
  source_tax_description: z.string().nullish(),
  source_tax_reduction_process_type: z.string().nullish(),
  source_tax_type: SourceTaxTypeSchema.nullish(),
  source_tax_rates: z
    .object({
      flat_basic_rate: z.string().nullish(),
      flat_reduced_rate: z.string().nullish(),
    })
    .nullish(),
});

export type SourceTaxType = z.infer<typeof SourceTaxTypeSchema>;
export type Country = z.infer<typeof CountrySchema>;
